module.exports = __webpack_public_path__ + "img/3DScan_2.6fbf6d44.png";